import { render } from "./menu3-1.vue?vue&type=template&id=1d2229fa"
import script from "./menu3-1.vue?vue&type=script&lang=ts"
export * from "./menu3-1.vue?vue&type=script&lang=ts"
script.render = render

export default script